<template>
    <!-- 教学管理 -->
    <div id="confirm">
        <el-tabs type="card">
            <el-tab-pane label="确认缴费">
                <el-table
                    :data="RecordData.datas"
                    ref="CourseData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    v-loading="loading"
                    element-loading-text="数据加载中，请稍等..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <el-table-column
                        prop="className"
                        label="班级"
                        show-overflow-tooltip
                        min-width="120"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="fee"
                        label="学费/元"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="materialCost"
                        label="材料费/元"
                        show-overflow-tooltip
                        v-if="ismast"
                    ></el-table-column>
                    <el-table-column
                        prop="allClassFee"
                        label="报名费/元"
                        show-overflow-tooltip
                        v-if="isbm"
                    ></el-table-column>
                    <el-table-column
                        prop="ageRemissionMoney"
                        label="年龄折扣/元"
                        show-overflow-tooltip
                        v-if="agediscount"
                    >
                        <template slot-scope="scope">
                            <span v-if="!scope.row.ageRemissionMoney"> 0 </span>
                            <span v-else>
                                {{ scope.row.ageRemissionMoney }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="identityRemission"
                        label="特殊身份减免/元"
                        show-overflow-tooltip
                        v-if="isspecial"
                    ></el-table-column>
                    <el-table-column
                        prop="subtotal"
                        label="小计/元"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="susFee"
                        label="休学抵消/元"
                        show-overflow-tooltip
                        v-if="transfer"
                    ></el-table-column>
                </el-table>
                <div
                    class="table-footer confirm-footer"
                    v-if="RecordData.datas"
                >
                    <div class="f-footer">
                        <div v-if="RecordData.preferentialMoney">
                            <span>学期报名优惠/￥:</span>
                            <span>{{ RecordData.preferentialMoney }}</span>
                        </div>
                        <div>
                            <span
                                >共{{
                                    RecordData.datas.length
                                }}个,合计/￥:</span
                            >
                            <span>{{
                                RecordData.total + RecordData.preferentialMoney
                            }}</span>
                        </div>
                        <el-button
                            type="primary"
                            @click="submitorder"
                            style="float: right"
                            >提交订单</el-button
                        >
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: "confirm",

    data() {
        return {
            isspecial: false,
            transfer: false,
            agediscount: false,
            ismast: false,
            isbm: false,
            RecordData: [],
            loading: false,
            isFirstEnter: false,
            orderForm: {
                clsIds: [],
                termId: "",
            },
        };
    },
    created() {
        this.$global.activeMenu = "2-3"; //不激活左侧
        this.isFirstEnter = true;
    },
    mounted() {
        let me = this;
        const data = JSON.parse(this.$route.params.param);
        this.RecordData = data;
        this.RecordData.datas.forEach(function (item, index) {
            if (item.susFee) {
                me.transfer = true;
            }
            if (item.identityRemission) {
                me.isspecial = true;
            }
            if (item.ageRemissionMoney) {
                me.agediscount = true;
            }
            if (item.materialCost) {
                me.ismast = true;
            }
            if (item.allClassFee) {
                me.isbm = true;
            }
        });
        this.getTerm();
    },

    activated() {
        if (!this.$route.meta.isBack || this.isFirstEnter) {
            const data = JSON.parse(this.$route.query.param);
            this.RecordData = data; // 把数据清空，可以稍微避免让用户看到之前缓存的数据
            this.getTerm();
        }
        this.$route.meta.isBack = false;
        this.isFirstEnter = false;
    },
    beforeRouteEnter(to, from, next) {
        if (from.name != "Pay") {
            to.meta.isBack = true;
        }
        next();
    },
    watch: {},
    methods: {
        async getTerm() {
            let me = this,
                param = {
                    type: "1",
                    planType: "1",
                };
            let res = await me.$userService.select(param);
            if (res && res["success"]) {
                me.orderForm.termId = res.content.term.id;
            }
        },
        async submitorder() {
            let me = this;
            me.RecordData.datas.forEach(function (item, index) {
                me.orderForm.clsIds.push(item.id);
            });
            let res = await me.$userService.submitOrder(me.orderForm);
            if (res && res["success"]) {
                me.orderForm = {
                    clsIds: [],
                    termId: "",
                };
                if (res.content.needPay) {
                    me.$router.replace({
                        name: "Paynow",
                        params: {
                            orderdatas: JSON.stringify(res.content),
                        },
                    });
                } else {
                    me.$message({
                        message: "缴费成功",
                        type: "success",
                    });
                    me.$router.replace({
                        name: "Order",
                        query: { param: "1" },
                    });
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#confirm {
    .pay-tip {
        border: 1px solid #ffca85;
        display: flex;
        align-items: center;
        margin: 20px 0;
        padding: 20px 10px;
        img {
            width: 35px;
            margin-right: 10px;
        }
        div {
            color: #ffca85;
            font-size: 16px;
        }
    }

    .table-footer {
        border: 1px solid #ebeef5;
        padding: 15px 10px;
        align-items: center;
        border-top: none;
        display: flex;
        justify-content: space-between;
        div {
            font-size: 16px;
            color: #0089e5;
        }
        .f-footer {
            display: flex;
            align-items: center;
            div {
                color: #545b6d;
                margin: 0 10px;
                span {
                    color: #ff8d3c;
                }
            }
        }
    }
    .confirm-footer {
        display: block;
        overflow: hidden;
        padding-right: 30px;
        .f-footer {
            float: right;
            display: block;
            div {
                margin: 20px 0;
                span:first-child {
                    display: inline-block;
                    width: 200px;
                    color: #545b6d;
                    text-align: right;
                    margin-right: 20px;
                }
            }
            div:nth-child(2) {
                span:last-child {
                    font-weight: 700;
                    font-size: 20px;
                }
            }
        }
    }
    .payMoney {
        font-size: 16px;
        color: #545b6d;
        text-align: center;
        span {
            font-size: 30px;
            color: #ff8d3c;
        }
    }
    .el-button--default {
        border-color: #ebeef5;
        color: #333;
    }
    .el-button {
        border-bottom: none;
        border-radius: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pay/confirm.vue